import classNames from 'classnames'
import { memo } from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import Icon from '@/components/Icon/Icon'

import styles from './LockButton.module.scss'

type Props = {
  persist: boolean
  togglePersist: () => void
}

const LockButton = ({ persist, togglePersist }: Props) => (
  <OverlayTrigger overlay={<Tooltip>{persist ? 'Settings saved!' : 'Save settings'}</Tooltip>} placement='top'>
    <div className={classNames(styles.lock, { [styles.locked]: persist })} onClick={togglePersist}>
      <Icon icon={persist ? 'lock' : 'unlock'} />
    </div>
  </OverlayTrigger>
)

export default memo(LockButton)
